/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Fonts_Add_Font_Button_LabelInputs */



/**
* | output |
* | --- |
* | "Insert new font" |
*
* @param {Options_Fonts_Add_Font_Button_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_fonts_add_font_button_label = /** @type {((inputs?: Options_Fonts_Add_Font_Button_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Fonts_Add_Font_Button_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Insérer une nouvelle police")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neue Schriftart einfügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci nuovo font")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставить новый шрифт")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar nueva fuente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("插入新字体")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいフォントを挿入")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया फ़ॉन्ट डालें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inserir nova fonte")
	return /** @type {LocalizedString} */ ("Insert new font")
});